import queryString from 'query-string-for-all';
import { FilterType } from 'src/types';

export const getFilterFromLocation = (
  location: Pick<Location, 'search'>
): FilterType[] => {
  const { filters } = queryString.parse(location.search);

  if (!filters) {
    return [];
  }

  const queryFilter = Array.isArray(filters)
    ? (filters as FilterType[])
    : (filters?.split(',') as FilterType[]);

  // Lazy hack to sanitize
  const allowedFilters = ['authorized_dealer'];
  const sanitizedFilters = queryFilter.filter(filter =>
    allowedFilters.some(a => a === filter)
  );

  return sanitizedFilters;
};
